export default "__VITE_ASSET__BbTK1a0B__"